import React from 'react'
import TheStory from '../OurStoryComponents/TheStory'
import AlkhairArchive from '../OurStoryComponents/AlkhairArchive'
import Adresss from '../OurStoryComponents/Adresss'

function OurStory() {
    return (

        <div className="flex flex-col mt-20 gap-10">
            <TheStory />
            <AlkhairArchive />
            <Adresss />
        </div>

    )
}

export default OurStory